/**
 * Created by or_p on 6/18/2016.
 */
import React, { Component } from 'react';
import BaseElementDialog from '../BaseElementDialog/BaseElementDialog';
import * as Colors from 'material-ui/styles/colors';
import _ from 'lodash';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import CustomWidthAndHeight from '../../EditorUI/BaseUI/CustomWidthAndHeight/CustomWidthAndHeight';
import YoutubeUrl from 'youtube-url';
import { getElementMethods } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import { elementTypes } from 'crazyEditor/components/Elements/index';
import FontIcon from 'material-ui/FontIcon';
import ElementDialogWrapper from '../ElementDialogWrapper/ElementDialogWrapper';

const VIDEO_SIZES = [
  {width: 480, height: 270},
  {width: 560, height: 315},
  {width: 640, height: 360},
  {width: 880, height: 495}
];

export default class VideoDialog extends Component {
  constructor(props) {
    super(props);

    this.getElementProps = this.getElementProps.bind(this);

    this.state = {
      errorText: null,
      videoSize: this.getVideoSizeFromProps(props),
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.open && nextProps.open) {
      this.setState({
        errorText: null,
        videoSize: this.getVideoSizeFromProps(nextProps),
      });
    }
  }

  onSizeSelected = (event, index, videoSize) => {
    this.setState({videoSize});
  };

  onUrlChange = () => {
    const {errorText} = this.state;
    if (errorText) {
      this.setState({errorText: null});
    }
    this.debouncedValidate();
  };

  getVideoSizeFromProps(props) {
    let videoSize = VIDEO_SIZES[0];
    if (props.selectedElement) {
      videoSize = _.pick(props.selectedElement.layout, ['width', 'height']);
      VIDEO_SIZES.forEach(videoSizeValue => {
        if (_.isEqual(videoSizeValue, videoSize)) {
          videoSize = videoSizeValue;
        }
      });
    }
    return videoSize;
  }

  getElementProps() {
    const elementMethods = getElementMethods(elementTypes.VideoElement);
    const url = this.refs.textField.getValue();
    return {
      layout: {
        width: this.state.videoSize.width,
        height: this.state.videoSize.height
      },
      data: {
        url: url,
        videoId: elementMethods.getVideoIdFromUrl(url)
      }
    };
  }

  validate = () => {
    const url = this.refs.textField.getValue();
    if (_.isEmpty(url)) {
      this.setState({errorText: 'URL can not be empty'});
    } else {
      if (!YoutubeUrl.valid(url)) {
        this.setState({errorText: 'Oops! we can\'t find a video at that URL. A typo maybe?'});
      } else {
        this.setState({errorText: null});
      }
    }
  };

  debouncedValidate = _.debounce(this.validate, 1000, {leading: true, trailing: true});

  render() {
    const {open, onCancel, onAddUpdate, newElement, selectedElement} = this.props;
    const {videoSize, errorText} = this.state;
    const isCustomSize = !_.includes(VIDEO_SIZES, videoSize);
    const elementMethods = getElementMethods(elementTypes.VideoElement);

    let videoUrl = '';
    if (!newElement) {
      videoUrl = elementMethods.getVideoUrl(selectedElement);
    }
    return (
      <BaseElementDialog
        open={open}
        newElement={newElement}
        title={`${newElement ? 'Add' : 'Edit'} Video`}
        ref="baseElementDialog"
        inputValid={!!(errorText === null && _.get(videoSize, 'width', false) && _.get(videoSize, 'height', false) && !_.isEmpty(_.get(this, 'refs.textField')))}
        onAddUpdate={() => onAddUpdate(this.getElementProps())}
        onCancel={() => onCancel()}
      >
        <div style={{width: '750px', marginLeft: 'auto', marginRight: 'auto', marginTop: 40}}>
          <TextField
            errorStyle={{float: 'left'}}
            style={{width: '100%'}}
            defaultValue={videoUrl}
            hintText="Insert Youtube Video URL"
            floatingLabelText="Youtube Video URL"
            errorText={errorText}
            onChange={this.onUrlChange}
            ref="textField"
          />
          <div style={{fontSize: 16, display: 'flex', alignItems: 'center', marginTop: 10}}>
            Video Size:
          <span>
            <SelectField
              style={{marginLeft: 25, width: 100}}
              value={isCustomSize ? null : videoSize}
              onChange={this.onSizeSelected}
            >
              {
                VIDEO_SIZES.map((size, index) => {
                  return <MenuItem key={index} value={size} primaryText={size.width + 'x' + size.height}/>;
                })
              }
              <MenuItem value={null} primaryText="Custom"/>
            </SelectField>
          </span>
          <span
            style={{marginLeft: 25}}
          >
            {
              isCustomSize &&
              <CustomWidthAndHeight
                defaultWidth={!newElement ? videoSize.width : null}
                defaultHeight={!newElement ? videoSize.height : null}
                onChange={(videoSize) => this.setState({videoSize})}
                label={''}
              />
            }
          </span>
          </div>
        </div>
      </BaseElementDialog>);
  }
}
